import React from 'react';

import {DefaultRootState, useDispatch, useSelector} from 'react-redux';
import {createSelector} from 'reselect';

import {FullHTMLLink} from 'app/components/general/FullHTMLLink';
import NoResultsMessage from 'app/components/general/NoResultsMessage';
import {CurrentUserSelector} from 'app/current-user/api';
import {showNotification} from 'app/toasts/slice';
import {HOME_REDIRECT} from 'app/urls';
import {gt} from 'app/utils/i18n';
import {sendSentryReportDialog} from 'app/utils/sentry';

import {AuthenticatedUserSerializedType} from 'sweet-types';

export const ErrorContent = (): JSX.Element => {
  const dispatch = useDispatch();
  const {userName, userEmail} = useSelector(userNameAndEmailSelector);

  return (
    <NoResultsMessage
      icon="fa-exclamation-triangle text-warning"
      head={gt('Could not open the page you requested')}
    >
      <p className="lead mb-0">
        {gt('There was an error loading the page you requested.')}
      </p>
      <p className="lead">
        {gt('Our system has been notified of the problem.')}
      </p>
      <p className="lead">
        {gt("If you'd like to help out you tell the team what happened.")}
      </p>
      <div>
        <button
          className="btn btn-primary"
          onClick={() => {
            sendSentryReportDialog({
              user: {
                name: userName,
                email: userEmail,
              },
            });
            dispatch(
              showNotification(
                gt('Thank you for your feedback! Your report has been sent.'),
                'success'
              )
            );
          }}
        >
          {gt('Report this error')}
        </button>
      </div>
      <div className="mt-3">
        <FullHTMLLink html_url={HOME_REDIRECT} className="btn btn-link">
          {gt('Back to home')}
        </FullHTMLLink>
      </div>
    </NoResultsMessage>
  );
};

const userNameAndEmailSelector = createSelector<
  DefaultRootState,
  {userName: string; userEmail: string},
  AuthenticatedUserSerializedType
>(
  (state) => CurrentUserSelector(state).data!,
  (user) => {
    return {
      userName: user.name,
      userEmail: user.email,
    };
  }
);
